import React, { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { subscribeSoftSuccess } from '../utils/softSuccess';

/**
 * Global soft success toast. Trigger via showSoftSuccess('Текст').
 */
export default function SoftSuccessToast() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('Сохранено');

  useEffect(() => {
    return subscribeSoftSuccess((next) => {
      setMessage(next);
      setOpen(true);
    });
  }, []);

  return (
    <Snackbar
      open={open}
      autoHideDuration={2600}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ mb: 1 }}
    >
      <Alert
        onClose={() => setOpen(false)}
        severity="success"
        variant="filled"
        icon={<CheckRoundedIcon fontSize="inherit" />}
        sx={{
          alignItems: 'center',
          borderRadius: 3,
          fontWeight: 600,
          boxShadow: '0 12px 28px rgba(16, 185, 129, 0.22)',
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
